/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useContext, useEffect, useState, useCallback } from 'react';
import TopBar from '../../components/TopBar';

import CardHeader from '../../components/CardHeader';
import TableSection from './components/Table';
import GlobalContext from '../../components/Context/GlobalContext';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import ItemShimmer from '../../components/Shimmer/itemShimmer';
import Pagination from '../../components/Pagination';
import { dataService } from '../../services/data.services';
import Confirmationpopup from './components/Confirmationpopup';
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';
import merchantSlice, { MerchantList } from './merchantSlice';
import Modalcustom from '../../components/CustomModal';
import EmailModal from './components/EmailModal';

const ManageMerchants = () => {

    const { isSideNavBar, setToastmessage, setToastError, setToastErrorMessage } = useContext(GlobalContext);
    const dispatch = useDispatch();
    const merchantList = useSelector(state => state.merchantState);
    const { List } = merchantList;
    const [modalpopup, setmodalpopup] = useState({})
    const [activateLoading, setactivateLoading] = useState(false)
    const [loading, setLoading] = useState(true);
    const [loadingActivation, setLoadingActivation] = useState(false);
    const [addOpen, setAddOpen] = useState(false)
    const location = useLocation();
    const [confirmationState, setConfirmationState] = useState({});
    const [sideModelType, setSideModelType] = useState('');
    const [searchParams, setSearchParams] = useSearchParams({ page_number: 1 });
    const [email, setemail] = useState('')
    const [tableLoading, setTableLoading] = useState(false)
    const [editValue, setEditValue] = useState({})
    const [emailClick, setEmailClick] = useState(false);
    const [checkboxClick, setCheckboxClick] = useState(false);
    const [checkedList, setCheckedList] = useState([]);
    const [sendemail, setSendemail] = useState(false)
    const [merchants, setMerchants] = useState();
    const [emailList, setemailList] = useState([]);
    const [emailModal, setemailModal] = useState(false);
    const [bodyContent, setBody] = useState('');
    const [bodyError, setBodyError] = useState('');
    const [bodyFocus, setBodyFocus] = useState(false);
    const [subject, setSubject] = useState('');
    const [subjectError, setSubjectError] = useState('');
    const [subjectFocus, setSubjectFocus] = useState(false);
    const [sendLoading, setSendLoading] = useState(false)


    const initialInputValue = {
        admin_first_name: '',
        admin_last_name: '',
        admin_email_address: '',
        admin_mobile_number: '',
        roles: []
    }
    const [emptyScreenMessage, setEmptyScreenMessage] = useState('');
    const [inputValue, setInputValue] = useState(initialInputValue);
    /**
     * The function sets the loading state to true and updates the search parameters with a page number
     * of 1.
     */

    const handleLoadData = () => {
        setLoading(true);
        let params = null
        params.page_number = 1
        params.filter = true
        params.status = true
        setSearchParams({ ...params })
    }
    function objectToQueryString(obj) {
        const keys = Object.keys(obj);
        let str = ''
        const keyValuePairs = keys.map((key, i) => {
            str += `${i === 0 ? `?` : '&'}${encodeURIComponent(key) + '=' + encodeURIComponent(obj[key])}`;
        });
        return str
        // more code goes here
    }
    const getAdminUserList = useCallback(async () => {
        setEmptyScreenMessage("")
        try {
            dispatch(MerchantList(searchParams)).then((response) => {
                if (response?.payload?.data?.success_status) {
                    if (Math.ceil(response?.payload?.data?.totat_count / 10) < Number(searchParams.get('page_number'))) {
                        if (response?.payload?.data?.totat_count !== 0) {
                            // setToastErrorMessage('Something went wrong. Please try again')
                            setEmptyScreenMessage("No data found");
                        } else {
                            setEmptyScreenMessage("No matching records found.")
                        }
                        setLoading(false);
                    } else {
                        setLoading(false);
                    }
                } else {
                    setLoading(false);
                    setEmptyScreenMessage("No data found");
                    // setToastErrorMessage('Something went wrong. Please try again')
                }
            })
            if (email === '') {
                setemail(localStorage.getItem('email'))
            }
        } catch (error) {
            handleLoadData()
            console.error(error);
        }
    }, [location]);



    /**
     * This function handles the click event of a page number and updates the search parameters with
     * the selected page number.
     */
    const handleOnClickPageNumber = (pageNum) => {
        setLoading(true);
        // setCheckboxClick(false)
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum.selected + 1 })
    }

    /**
     * This function updates search parameters with a new key-value pair and sets the page number to 1.
     */
    const handleSearchParams = (key, value, del) => {
        setLoading(true);
        let params = Object.fromEntries(searchParams);
        if (del) {
            delete params[del]
        } else {
            params.page_number = 1
            if (key === 'search') {
                params[key] = encodeURIComponent(value)
            }
            else {
                if (params[key] != value) {
                    params[key] = value
                } else {
                    delete params.status;
                }

            }
            if (params.search === '') delete params.search

        }
        setSearchParams({ ...params })


    }

    const handleFilters = (key, value) => {
        setLoading(true);
        let params = Object.fromEntries(searchParams);
        params.page_number = 1
        params.filter = true
        if (key === 'all') {
            delete params['filter'];
            delete params['status'];
        }
        else params[key] = value
        setSearchParams({ ...params })
    }

    /* `useEffect(() => { getAdminUserList(); }, [getAdminUserList]);` is a hook that is used to run
    the `getAdminUserList` function whenever the `getAdminUserList` function changes. In this case,
    the `getAdminUserList` function is memoized using the `useCallback` hook, which means that it
    will only be redefined if the `location` value changes. Therefore, the `useEffect` hook will run
    the `getAdminUserList` function whenever the `location` value changes. This hook is used to
    fetch the list of admin users from the server and update the `tableData` state with the response
    data. */
    useEffect(() => {

        getAdminUserList();
    }, [getAdminUserList]);

    /**
     * This function handles the click event for a side popup by resetting an input value and toggling
     * the state of a boolean variable.
     */
    const handleSidePopupClick = (type, item) => {
        if (type === 'Edit') {
            setInputValue({
                admin_first_name: item.first_name,
                admin_last_name: item.last_name,
                admin_email_address: item.email_address,
                admin_mobile_number: item.mobile_number,
                roles: item.roles
            })
            setEditValue(item)
        } else {
            setInputValue(initialInputValue)
        }
        setSideModelType(type);
        handleConformationClick()
        setAddOpen(!addOpen);
    }
    /**
     * The function sets the confirmation state to an empty object when a confirmation click event
     * occurs.
     */
    const handleConformationClick = () => {
        setConfirmationState({});
    }
    const handleExport = async () => {
        let params = Object.fromEntries(searchParams);
        delete params.page_number
        const body = { ...params }
        let url = ''
        url = searchParams.get('sort')
        let search = ''
        search = searchParams.get('search');
        params = objectToQueryString(params);
        // const res = await dataService.GetAPI(`merchant-users/export-csv${url !== null ? `?sort=${url}` : ''}`);
        const res = await dataService.GetAPI(`merchant-users/export-csv${params}`)
        if (!res.error) {
            window.open(
                res.data.url,
                '_blank'
            );
            // window.location.href = res.data.url
            setToastmessage('File Exported Successfully')
        }

    }

    /**
     * Fetches all stores for a merchant (handling pagination)
     */
    const fetchAllStoresForMerchant = async (merchantEmail) => {
        const allStores = [];
        let pageNumber = 1;
        let hasMorePages = true;

        while (hasMorePages) {
            try {
                const encodedEmail = encodeURIComponent(merchantEmail);
                const res = await dataService.GetAPI(`stores/list?page_number=${pageNumber}&merchant=${encodedEmail}`);
                
                if (!res.error && res.data?.data) {
                    allStores.push(...res.data.data);
                    const totalPages = Math.ceil(res.data.total_count / 10);
                    hasMorePages = pageNumber < totalPages;
                    pageNumber++;
                } else {
                    hasMorePages = false;
                }
            } catch (error) {
                console.error('Error fetching stores:', error);
                hasMorePages = false;
            }
        }

        return allStores;
    }

    /**
     * Deactivates all active stores for a merchant
     * Returns an object with success count and total count
     */
    const deactivateAllStoresForMerchant = async (merchantEmail) => {
        try {
            const stores = await fetchAllStoresForMerchant(merchantEmail);
            const activeStores = stores.filter(store => store.status === true);
            
            if (activeStores.length === 0) {
                return { successCount: 0, totalCount: 0 };
            }

            // Process stores in batches to avoid overwhelming the network
            const batchSize = 10;
            let successCount = 0;
            let failedCount = 0;

            for (let i = 0; i < activeStores.length; i += batchSize) {
                const batch = activeStores.slice(i, i + batchSize);
                
                // Deactivate stores in current batch
                const batchPromises = batch.map(async (store) => {
                    try {
                        const storeEmail = encodeURIComponent(store.email_address);
                        const res = await dataService.PatchAPI(
                            { status: 'false' },
                            `stores/activate-deactivate?email=${storeEmail}`
                        );
                        if (!res.error) {
                            return { success: true, store: store.email_address };
                        } else {
                            console.error(`Error deactivating store ${store.email_address}:`, res.data?.message);
                            return { success: false, store: store.email_address };
                        }
                    } catch (error) {
                        console.error(`Error deactivating store ${store.email_address}:`, error);
                        return { success: false, store: store.email_address };
                    }
                });

                // Use Promise.allSettled to handle partial failures gracefully
                const results = await Promise.allSettled(batchPromises);
                
                results.forEach((result) => {
                    if (result.status === 'fulfilled' && result.value.success) {
                        successCount++;
                    } else {
                        failedCount++;
                    }
                });

                // Add a small delay between batches to avoid overwhelming the server
                if (i + batchSize < activeStores.length) {
                    await new Promise(resolve => setTimeout(resolve, 100));
                }
            }

            return { successCount, totalCount: activeStores.length, failedCount };
        } catch (error) {
            console.error('Error deactivating stores:', error);
            return { successCount: 0, totalCount: 0, failedCount: 0, error: true };
        }
    }

    const handleActivate = async () => {
        setactivateLoading(true)
        const body = {
            status: modalpopup.status === true ? 'false' : 'true'
        }
        try {
            const encodedEmail = encodeURIComponent(modalpopup['email_address']);
            const res = await dataService.PatchAPI(body, `merchant-users/activate-deactivate?${encodedEmail}`);
            if (!res.error) {
                // If deactivating merchant, also deactivate all associated stores
                if (modalpopup.status === true) {
                    try {
                        const storeDeactivationResult = await deactivateAllStoresForMerchant(modalpopup['email_address']);
                        if (storeDeactivationResult.error) {
                            // If there was an error fetching stores, still show success for merchant
                            setToastmessage(`Merchant user deactivated successfully. Unable to deactivate stores.`)
                        } else if (storeDeactivationResult.successCount > 0) {
                            if (storeDeactivationResult.failedCount > 0) {
                                setToastmessage(`Merchant user deactivated successfully. ${storeDeactivationResult.successCount} of ${storeDeactivationResult.totalCount} store(s) deactivated.`)
                            } else {
                                setToastmessage(`Merchant user deactivated successfully. ${storeDeactivationResult.successCount} store(s) have been deactivated.`)
                            }
                        } else {
                            setToastmessage(`Merchant user deactivated successfully`)
                        }
                    } catch (storeError) {
                        // If store deactivation fails, still show success for merchant deactivation
                        console.error('Error during store deactivation:', storeError);
                        setToastmessage(`Merchant user deactivated successfully. Some stores may not have been deactivated.`)
                    }
                } else {
                    setToastmessage(`Merchant user activated successfully`)
                }
                setactivateLoading(false);
                setmodalpopup({});
                getAdminUserList();

            } else {
                setToastErrorMessage(res.data.message);
                setactivateLoading(false);

            }

        } catch (error) {
            setToastErrorMessage(error.response?.data?.message || error.message || 'An error occurred');
            setactivateLoading(false);
            setmodalpopup({})

        }



    }

    /**
     * This function handles the activation of a user account and updates the user list accordingly.
     */
    const handleCheckbox = (key) => {
        let array = [...emailList];

        if (key === 'select_all_page') {
            List?.data?.forEach(item => {
                if (!array.includes(item._id)) {
                    array.push(item._id);
                }
            });
        } else if (key === 'delete') {
            List?.data?.forEach(item => {
                array = array.filter(id => id !== item._id);
            });
        }

        setemailList(array);
    }
    useEffect(() => {
        setMerchants('')
    }, [searchParams])

    const handleClose = () => {
        setmodalpopup(false);
        setemailModal(false);
        setSubject('')
        setBody('')
        setSubjectError(false)
        setBodyError(false);
        setSubjectFocus(false);
        setBodyFocus(false);
    }
    const handleSubmit = async () => {
        if (bodyContent.trim().length > 2000 && subject.trim().length > 200) {
            setSubjectError('Description too long. Max 200 characters.');
            setBodyError('Description too long. Max 2000 characters.');
            return;
        } else if (bodyContent.trim().length > 2000 && subject.trim().length == 0) {
            setSubjectError('This field is mandatory');
            setBodyError('Description too long. Max 2000 characters.');
            return;
        } else if (subject.trim().length > 200 && bodyContent.trim().length == 0) {
            setSubjectError('Description too long. Max 200 characters.');
            setBodyError('This field is mandatory');
            return;
        }
        if (subject.trim().length > 200) {
            setSubjectError('Description too long. Max 200 characters.');
            return;
        } else if (subject.trim().length == 0 || bodyContent.trim().length == 0) {
            if (subject.trim().length == 0) {
                setSubjectError('This field is mandatory');
            }
           
            if (bodyContent.trim().length == 0) {
                setBodyError('This field is mandatory');
            }
            return;
        }
        if (bodyContent.trim().length > 2000) {
            setBodyError('Description too long. Max 2000 characters.');
            return;
        }
        if (bodyContent.trim().length > 2000 && subject.trim().length > 200) {
            setSubjectError('Description too long. Max 200 characters.');
            setBodyError('Description too long. Max 2000 characters.');
            return;
        }
        let body = {}
        if (merchants === 'select_all') {
            body['merchant_id'] = 'ALL';
            body['subject'] = subject.trim();
            body['email_content'] =bodyContent.trim()
        } else {
            body['merchant_id'] = emailList;
            body['subject'] = subject.trim();
            body['email_content'] =bodyContent.trim()
        }
        try {
            setSendLoading(true)
            let params = Object.fromEntries(searchParams);
            delete params['sort'];
            delete params['page_number'];
            let response = await dataService.PostAPI(body, `merchant-users/send-email-to-merchant?${new URLSearchParams(params).toString()}`);
            if (!response?.error) {
                setToastmessage(response?.data?.message);
                setemailModal(false);
                setSubject('')
                setBody('')
                setSubjectError(false)
                setBodyError(false);
                setSubjectFocus(false);
                setBodyFocus(false);
                setemailList([]);
                setMerchants('');
                setSendemail(false);
            }
            setSendLoading(false);
        } catch (error) {
            console.log(error, 'errrr')
            setToastError('An error occured')
            setSendLoading(false);
        }
    }
    return (
        <>
            <CardHeader header={'Merchants'} noIcon>
                <div className="bg-[#f5f5f5] px-[15px] pb-[14px] pt-[14px] overflow-y-hidden mt-[110px] userHeight">
                    <div className='bg-white h-customh10 relative z-[12] p-6'>
                        <TopBar
                            AddButton={emptyScreenMessage === 'No data found' ? false : true}
                            SearchInput={emptyScreenMessage === 'No data found' ? false : true}
                            Tittle={'Merchant List'}
                            status={searchParams.get('status')}
                            AddButtonName={'Add User'}
                            SearchValue={!searchParams.get('search') ? '' : decodeURIComponent(searchParams.get('search')) || ''}
                            handleOnClickSearch={handleSearchParams}
                            handleFilters={handleFilters}
                            createPath="/manage-merchants/create"
                            handleSidePopupClick={handleSidePopupClick}
                            handleExport={handleExport}
                            tooltip="Onboard Merchant"
                            tooltipEmail="Send Email"
                            searchText="Merchant Name, Business Name"
                            isFilter
                            privilegeRequired={`send_email`}
                            manageMerchantList={`Merchant List`}
                            // emailClick={emailClick}
                            // setEmailClick={setEmailClick}
                            // setCheckboxClick={setCheckboxClick}
                            List={List}
                            emailList={emailList}
                            sendemail={sendemail}
                            merchants={merchants}
                            setSendemail={setSendemail}
                            setMerchants={setMerchants}
                            setemailList={setemailList}
                            setemailModal={setemailModal}
                        />
                        {(merchants === 'select_all_page' || merchants === 'select_all') && <div>
                            <div className='border border-[#EB9DC7] py-2 mt-4 flex justify-center items-center gap-4'>
                                {merchants === 'select_all_page' && <p className='font-normal text-xs text-[#000000]'>{`All ${List?.total_count > 10 ? '10' : List?.total_count} Merchants on this page are selected.`}</p>}
                                {List?.total_count > 10 && <p data-testid="select-all-btn" className={`${merchants === 'select_all' ? 'text-[#000000]' : 'text-[#9E2064] cursor-pointer'} text-xs `} onClick={() => setMerchants('select_all')}>{`${merchants === 'select_all_page' ? `Select all ${List?.total_count} Merchants ` : `All ${List?.total_count} Merchants are selected`}`}</p>}
                            </div>
                        </div>}
                        {<TableSection
                            List={List}
                            handleSearchParams={handleSearchParams}
                            setCheckboxClick={setCheckboxClick}
                            checkboxClick={checkboxClick}
                            emailClick={emailClick}
                            setEmailClick={setEmailClick}
                            tableLoading={loading}
                            searchParams={searchParams}
                            setmodalpopup={setmodalpopup}
                            modalpopup={modalpopup}
                            checkedList={checkedList}
                            setCheckedList={setCheckedList}
                            // isHeaderCheckboxChecked={isHeaderCheckboxChecked}
                            // setIsHeaderCheckboxChecked={setIsHeaderCheckboxChecked}
                            sendemail={sendemail}
                            setSendemail={setSendemail}
                            merchants={merchants}
                            setMerchants={setMerchants}
                            handleCheckbox={handleCheckbox}
                            emailList={emailList}
                            setemailList={setemailList}
                        />}
                        {!loading && Math.ceil(List?.total_count / 10) > 1 &&
                            <Pagination
                                selectedPageNumber={searchParams.get('page_number')}
                                handleOnClickPageNumber={handleOnClickPageNumber}
                                TotalCount={List?.total_count}
                                totalPageNumber={Math.ceil(List?.total_count / 10)}
                                // onPageChangeCallback={() => {
                                //     setHeaderCheckbox(false);
                                //     setCheckedMerchants([]);
                                // }}
                                emailList={emailList} merchants={merchants} selection={sendemail}
                            />}
                    </div>
                </div>
                <Modal open={Object.keys(modalpopup).length > 0} onClose={handleClose}>
                    <Confirmationpopup
                        message={`Are you sure you want to ${modalpopup.status === true ? 'deactivate' : 'Activate'} the merchant ${modalpopup.name}? `}
                        Title={`${modalpopup.status === true ? 'Deactivate' : 'Activate'} Merchant`}
                        handleSubmit={handleActivate}
                        stateKey={`${modalpopup.status === true ? 'Deactivate' : 'Activate'}`}
                        loading={activateLoading}
                        handleClose={handleClose}
                    />

                </Modal>
                <Modalcustom open={emailModal} container={'h-fit mt-[100px]'} onClose={handleClose}>
                    <EmailModal
                        handleSubmit={handleSubmit}
                        subjectFocus={subjectFocus}
                        setSubjectFocus={setSubjectFocus}
                        bodyFocus={bodyFocus}
                        setBodyFocus={setBodyFocus}
                        subject={subject}
                        bodyContent={bodyContent}
                        setSubject={setSubject}
                        subjectError={subjectError}
                        setSubjectError={setSubjectError}
                        setBody={setBody}
                        bodyError={bodyError}
                        setBodyError={setBodyError}
                        loading={sendLoading}
                        handleClose={handleClose}
                    />
                </Modalcustom>
            </CardHeader>

        </>
    );
}

export default ManageMerchants;
